module.exports = __webpack_public_path__ + "static/media/welcome-banner-space-listing.71d7e491.png";